<div class="container-fluid filter-box">
  <div class="col-12 d-flex mb-2 filter-content">
    <input
      type="text"
      class="form-control filter-input text-start"
      (keyup)="filterResults()"
      [(ngModel)]="searchTerm"
      placeholder="{{ 'companies.search' | translate }}"
    />
    <button class="btn btn-primary ms-2" (click)="openNewBlockModal()">
      {{ 'training.new_block' | translate }}
    </button>
  </div>
</div>
<div class="container-fluid filter-box">
  <div class="col-12 d-flex mb-4 filter-content mt-3">
    <button
      class="btn btn-primary ms-2"
      [class.active]="activeTab === 'active'"
      (click)="dataList('active')"
    >
      {{ 'training.active_tab' | translate }}
    </button>
    <button
      class="btn btn-primary ms-2"
      [class.active]="activeTab === 'inactive'"
      (click)="dataList('inactive')"
    >
      {{ 'training.inactive_tab' | translate }}
    </button>
  </div>
</div>
<div class="mat-elevation-z2">
  <table mat-table [dataSource]="dataSource" matSort class="fixed-table" class="w-100 tables">
    <ng-container matColumnDef="sort">
      <th mat-header-cell *matHeaderCellDef>{{ 'training.sort' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <div class="d-flex flex-column m-2">
          <img
            *ngIf="element.ordering > 1"
            class="arrow m-1"
            src="../../../assets/icons/icon_arrow_up.png"
            alt=""
            (click)="sortUpDown(element.ordering, 'up')"
          />
          <img
            *ngIf="blocks.indexOf(element) != blocks.length - 1"
            class="arrow m-1"
            src="../../../assets/icons/icon_arrow_down.png"
            alt=""
            (click)="sortUpDown(element.ordering, 'down')"
          />
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="ordering">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'training.order' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{element.ordering}}</td>
    </ng-container>
    <ng-container matColumnDef="url">
      <th mat-header-cell *matHeaderCellDef>{{ 'Training Block URL' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <a
          [ngClass]="{
            'block-link': activeTab === 'active',
            'block-link-inactive': activeTab === 'inactive'
          }"
          [href]="element.url"
          target="_blank"
          >{{element.url}}</a
        >
      </td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'proposals_and_orders.date' | translate }}
      </th>
      <td [class.block-link-inactive]="activeTab === 'inactive'" mat-cell *matCellDef="let element">
        {{ element.createdAt | date: 'dd-MM-yyyy'}}
      </td>
    </ng-container>
    <ng-container matColumnDef="details">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div class="d-flex justify-content-end align-items-center">
          <div class="btn btn-xs-small" (click)="getSelectedBlock(element.id)">details</div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="reactivate">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div class="d-flex justify-content-end align-items-center">
          <div class="btn btn-xs-small" (click)="openReactivationModal(element.id)">
            {{ 'training.reactivate' | translate }}
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
</div>

<!-- MODAL TO SHOW DETAILS -->
<div *ngIf="detailBlockModal" class="modal-container">
  <div class="modal-content">
    <div class="close-btn">
      <img src="../../../assets/icons/close.png" alt="" (click)="closeModal()" />
    </div>
    <h2 class="text-left">{{ 'training.edit_block'| translate }}</h2>
    <form #blockForm="ngForm" class="mt-3">
      <div class="container-fluid form-container" *ngIf="block">
        <div class="row">
          <div class="col-12 col-xl-6 mb-3">
            <label for="">{{ 'URL' | translate }}</label>
            <input
              name="url"
              type="text"
              class="form-control"
              [required]="block.url != '' "
              [(ngModel)]="block.url"
              pattern="^(https?:\/\/)?(www\.)?([\w-]+\.)+[\w]{2,}(\/.*)?$"
              #url="ngModel"
            />
            <div *ngIf="url.invalid && (url.dirty || url.touched)" class="error-message">
              <div *ngIf="url.errors.required">URL is required.</div>
              <div *ngIf="url.errors.pattern">Invalid URL format.</div>
            </div>
            <div *ngIf="activeTab === 'active'" class="w-100 d-flex justify-content-center mt-4">
              <button
                class="btn btn-primary me-2"
                (click)="handleBlockAction('save', block)"
                [disabled]="!(block.url && block.url != '' && url.valid)"
              >
                {{ 'company_detail.btn_save' | translate }}
              </button>
              <button class="btn btn-danger me-2" (click)="openDeleteBlockModal()">
                {{ 'user.btn_delete' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- MODAL FOR ADDING NEW BLOCK -->
<div *ngIf="newBlockModal" class="modal-container">
  <div class="modal-content">
    <div class="error-box">
      <span *ngIf="error" class="error col-12 col-xl-8"> {{ errorMessage }} </span>
    </div>
    <div class="close-btn">
      <img src="../../../assets/icons/close.png" alt="" (click)="closeModal()" />
    </div>
    <h2 class="text-left">{{ 'training.new_block_header'| translate }}</h2>
    <form #blockForm="ngForm" class="mt-3">
      <div class="container-fluid form-container">
        <div class="row">
          <div class="col-12 col-xl-6 mb-3">
            <label for="">{{ 'URL' | translate }}</label>
            <input
              name="url"
              type="text"
              class="form-control"
              placeholder="https://example.com"
              [required]="block.url != '' "
              [(ngModel)]="block.url"
              pattern="^(https?:\/\/)?(www\.)?([\w-]+\.)+[\w]{2,}(\/.*)?$"
              #url="ngModel"
            />
            <div *ngIf="url.invalid && (url.dirty || url.touched)" class="error-message">
              <div *ngIf="url.errors.required">URL is required.</div>
              <div *ngIf="url.errors.pattern">Invalid URL format.</div>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-center">
            <button
              class="btn btn-primary me-2"
              (click)="handleBlockAction('save', block)"
              [disabled]="!(block.url && block.url != '' && url.valid)"
            >
              {{ 'company_detail.btn_save' | translate }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- MODAL TO CONFIRM DELETE -->
<div *ngIf="deleteBlockModal" class="modal-container">
  <div class="modal-content text-center">
    <div class="close-btn">
      <img src="../../../assets/icons/close.png" alt="" (click)="closeModal()" />
    </div>
    <h2>{{ 'training.delete_block'| translate }}</h2>
    <form #quizForm="ngForm">
      <div class="container-fluid form-container">
        <div class="row">
          <div class="w-100 d-flex justify-content-center mt-4">
            <button class="btn btn-primary me-2" (click)="handleBlockAction('delete', block)">
              {{ 'training.confirm_delete' | translate }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- MODAL TO REACTIVATE BLOCK -->
<div *ngIf="reactivationModal" class="modal-container">
  <div class="modal-content text-center">
    <div class="close-btn">
      <img src="../../../assets/icons/close.png" alt="" (click)="closeModal()" />
    </div>
    <h2>{{ 'training.reactivate_block'| translate }}</h2>
    <form #quizForm="ngForm">
      <div class="container-fluid form-container">
        <div class="row">
          <div class="w-100 d-flex justify-content-center mt-4">
            <button class="btn btn-primary me-2" (click)="reactivateBlock()">
              {{ 'training.confirm_reactivation' | translate }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- RESPONSE MODAL -->
<div *ngIf="infoModal" class="modal-container" (click)="closeModal()">
  <div class="modal-content text-center">
    <div class="close-btn">
      <img src="../../../assets/icons/close.png" alt="" />
    </div>
    <h2>{{ modalText | translate }}</h2>
  </div>
</div>

<div *ngIf="loadingIndicator " class="modal-container loading-indicator">
  <div class="d-flex justify-content-start align-items-center">
    <div class="loader"></div>
  </div>
</div>
